// extracted by mini-css-extract-plugin
module.exports = {"TASK_TOOLTIP_HEIGHT":"92","TASK_TOOLTIP_WIDTH":"150","TASK_TOOLTIP_WIDTH_MAX":"216"};